<template>
  <svg width="68" height="76" viewBox="0 0 68 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2236_128483)">
      <path
        d="M8.5 12.1562C8.50036 7.86484 13.3998 5.13341 17.3662 7.20312L17.7471 7.41797L56.7676 31.2617C60.2967 33.4182 60.4071 38.2009 57.0986 40.5215L56.7676 40.7383L17.7471 64.582C13.7212 67.0416 8.50038 64.2735 8.5 59.8438V12.1562Z"
        fill="white"
        stroke="#00CFFF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2236_128483"
        x="0"
        y="0"
        width="68"
        height="76"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2236_128483" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2236_128483"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
